export default __webpack_public_path__ + "static/media/warning--domestic-animals--g3.ff1fdd4d.png";